import { VENDA_EM_MASSA} from '../../actions/types'

const initialState = undefined

export default function reducerVendaEmMassa (state = [], action = initialState) {
  switch (action.type) {
    case VENDA_EM_MASSA: {
      return action.payload;
    }
    default: {
      return state
    }
  }
}
